import { WizardStepName } from '../../../data/ppoints/constants';
import { WizardStepModel } from './WizardStepModel';

export const wizardSteps: WizardStepModel[] = [
    /**
     * Title is fetched from useWizardTitle because it returns translated title.
     */

    {
        name: WizardStepName.choose_service_provider,
        title: '',
    },
    {
        name: WizardStepName.shipping_zone_rate,
        title: '',
    },
    {
        name: WizardStepName.integration_mode_step,
        title: '',
    },
    {
        name: WizardStepName.app_extensions,
        title: '',
    },

    {
        name: WizardStepName.summary,
        title: '',
    },
];

// i18next.on('languageChanged', function (lng) {
//     //i18next.reloadResources();
//     console.log(lng);
//
//     wizardSteps[0].title = i18next.t('WIZARD.SHIPPING_ZONES_STEP.TITLE');
//     wizardSteps[1].title = i18next.t('WIZARD.APIKEY_STEP.TITLE');
//     wizardSteps[2].title = i18next.t('WIZARD.SHIPPING_RATES_STEP.TITLE');
//     wizardSteps[3].title = i18next.t('WIZARD.SUMMARY_STEP.TITLE');
// });
